<template>
  <block-item-card
    v-if="franchiseStrength"
    :min-height="minBlockHeight"
    :title="$t('Rates.Section.FranchiseStrength.Title')"
    :tooltip="$t('Rates.Section.FranchiseStrength.Tooltip')"
    class="fill-height d-flex flex-column"
  >
    <div
      class="py-5 px-4 d-flex justify-start flex-column flex-grow-1"
      style="width: 100%; gap:20px;"
    >
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <div class="d-flex flex-column justify-center">
            <p class="pa-0 ma-0 font-weight-medium">
              {{ $t('Rates.Section.FranchiseStrength.CurrentQuarter') }}
            </p>
            <p class="pa-0 ma-0 font-weight-light">
              {{ $t('Rates.Section.FranchiseStrength.Strength') }}
            </p>
          </div>
          <p class="pa-0 ma-0 text-size-28 font-weight-bold">
            {{ toPct(franchiseStrength.currentQuarter) }}
          </p>
        </div>
        <v-progress-linear
          :value="currentQuarterNormalized"
          color="synthesis-ui-green-02"
          height="12"
          rounded
          background-color="synthesis-ui-grey-06"
        />
        <div
          class="d-flex justify-space-between synthesis-ui-grey-01--text text-size-12"
        >
          <p class="pa-0 ma-0">
            {{ toPct(franchiseStrength.min) }}
          </p>
          <p class="pa-0 ma-0">
            {{ toPct(franchiseStrength.max) }}
          </p>
        </div>
      </div>
      <div
        class="d-flex flex-column"
        style="width: 100%; gap: 10px;"
      >
        <div
          class="d-flex justify-space-between align-center"
          style="width: 100%;"
        >
          <div class="d-flex flex-column justify-center">
            <p class="pa-0 ma-0 font-weight-medium">
              {{ $t('Rates.Section.FranchiseStrength.12MonthsAgo') }}
            </p>
            <p class="pa-0 ma-0 font-weight-light">
              {{ $t('Rates.Section.FranchiseStrength.Strength') }}
            </p>
          </div>
          <p class="pa-0 ma-0 text-size-28 font-weight-bold">
            {{ toPct(franchiseStrength.twelveMonthsAgo) }}
          </p>
        </div>
        <div>
          <v-progress-linear
            :value="twelveMonthsAgoNormalized"
            color="synthesis-ui-green-02"
            height="12"
            rounded
            background-color="synthesis-ui-grey-06"
          />
          <div
            class="d-flex justify-space-between mt-3 synthesis-ui-grey-01--text text-size-12"
          >
            <p class="pa-0 ma-0">
              {{ toPct(franchiseStrength.min) }}
            </p>
            <p class="pa-0 ma-0">
              {{ toPct(franchiseStrength.max) }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </block-item-card>
</template>

  <script>
import BlockItemCard from '@/theme/default/components/common/BlockItemCard'
import chartsColorMixin from '@/theme/default/components/charts/mixins/chartsColorMixin'

export default {
  name      : 'FranchiseStrength',
  components: {
    BlockItemCard
  },
  mixins   : [chartsColorMixin],
  props    : {},
  dataStore: {
    FindBankRegressionData: 'Rates.FindBankRegressionData.Data'
  },
  data () {
    return {
      minBlockHeight: 350,
      chartHeight   : 120
    }
  },
  computed: {
    franchiseStrength () {
      return this.FindBankRegressionData?.bank?.franchiseStrength
    },
    currentQuarterNormalized () {
      if (!this.franchiseStrength || this.franchiseStrength.max === this.franchiseStrength.min) {
        return 0
      }
      const range = this.franchiseStrength.max - this.franchiseStrength.min
      const normalized = ((this.franchiseStrength.currentQuarter - this.franchiseStrength.min) / range) * 100
      return Math.min(Math.max(normalized, 0), 100)
    },
    twelveMonthsAgoNormalized () {
      if (!this.franchiseStrength || this.franchiseStrength.max === this.franchiseStrength.min) {
        return 0
      }
      const range = this.franchiseStrength.max - this.franchiseStrength.min
      const normalized = ((this.franchiseStrength.twelveMonthsAgo - this.franchiseStrength.min) / range) * 100
      return Math.min(Math.max(normalized, 0), 100)
    }
  },
  created () {},
  methods: {
    toPct (v) {
      return `${v}%`
    }
  }
}
  </script>

  <style scoped>
  .border-top {
    border-top: 1px solid #e0e0e0;
  }
  .text-medium-emphasis {
    color: rgba(0, 0, 0, 0.6) !important;
  }
  .synthesis-brand-dark-blue--text {
    color: #041F30 !important;
  }
  .chart {
    width: 100%;
  }
  </style>
